import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "onInput"]

import { ref, toRaw, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OTPInputComponent',
  props: {
  context: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;



// number of digits to display
const digits = Number(props.context.digits);

// get value from context object
const tmp = ref(props.context.value || "");

// get value from input and pass to context object
function handleInput(index: number, e: any) {
  console.log(`Input ${index}: `, e.target.value);

  const prev = tmp.value;
  console.log("PREV: ", prev);

  if (tmp.value.length <= index) {
    // If this is a new digit
    tmp.value = '' + tmp.value + e.target.value
  } else {
    // If this digit is in the middle somewhere, cut the string into two
    // pieces at the index, and insert our new digit in.
    tmp.value =
      '' +
      tmp.value.substr(0, index) +
      e.target.value +
      tmp.value.substr(index + 1)
  }

  // Get all the digit inputs
  const inputs = e.target.parentElement.querySelectorAll('input')

  if (index < digits - 1 && tmp.value.length >= prev.length) {
    // If this is a new input and not at the end, focus the next input
    inputs.item(index + 1).focus()
  } else if (index > 0 && tmp.value.length < prev.length) {
    // in this case we deleted a value, focus backwards
    inputs.item(index - 1).focus()
  }

  if (tmp.value.length === digits) {
    // If our input is complete, commit the value.
    props.context.node.input(tmp.value)
  } else if (tmp.value.length < digits && props.context.value !== '') {
    // If our input is incomplete, it should have no value.
    props.context.node.input('')
  }
}

/**
 * On focus, select the text in our input.
 */
function handleFocus(e: any) {
  e.target.select()
}

/**
 * Handle the paste event.
 */
function handlePaste(e: any) {
  const paste = e.clipboardData.getData('text')
  if (typeof paste === 'string') {
    // If it is the right length, paste it.
    tmp.value = paste.substr(0, digits)
    const inputs = e.target.parentElement.querySelectorAll('input')
    // Focus on the last character
    inputs.item(tmp.value.length - 1).focus()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(digits), (idx) => {
    return (_openBlock(), _createElementBlock("input", {
      type: "number",
      maxlength: "1",
      onFocus: handleFocus,
      onPaste: handlePaste,
      value: tmp.value[idx - 1] || '',
      key: idx,
      onInput: ($event: any) => (handleInput(idx - 1, $event)),
      class: "w-12 h-12 flex flex-col items-center justify-center text-center px-1 outline-none rounded-md border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blaze-orange-600"
    }, null, 40, _hoisted_1))
  }), 128))
}
}

})